import { Autocomplete, Box, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { useValue } from '../../../context/ContextProvider';
import { ObtenerInformacionProducto } from '../../../actions/almacen';
import ReadOnlyRowMoverAdd from './components/ReadOnlyRowMoverAdd';
import EditRowMoverAdd from './components/EditRowMoverAdd';

const AlmacenMover = ({ currentUser, dispatch, productosOptions, setDisponibilidadProducto }) => {
    const { state: { productos } } = useValue();
    const [nombreProductoState, SetNombreProductoState] = useState('');
    const [codigoBarrasState, setCodigoBarrasState] = useState('');
        
    const [moverProductos, setMoverProductos] = useState([]);
    const codigoBarrasRef = useRef();

    

    const handleCodigoBarrasBlur = (event) => {
        //event.preventDefault();
        if (codigoBarrasState != "") {
            //console.log('Cod Bar Text: ', codigoBarrasState);
            const productoEncontrado = productos.find((producto) => producto.codBar == codigoBarrasState);
            //console.log({ productoEncontrado });
            if (productoEncontrado) {
                SetNombreProductoState(productoEncontrado.product);
                //setMarcaState(productoEncontrado.nombreMarca);
                //setCategoriaState(productoEncontrado.nombreCategoria);
                //llenarDatosExtra(productoEncontrado.nombreProducto);
            } else {
                setCodigoBarrasState("");
                SetNombreProductoState("");
                //setMarcaState("");
                //setCategoriaState("");
                //codigoBarrasRef.current.focus();
            }
        }
    }

    const handleCodigoBarrasEnter = () => {
        //cantidadRef.current.focus();     //Pasa focus a otro elemento
    }

    const handleProductoChange = (event, value, reason) => {
        //console.log({ event, value, reason });
        SetNombreProductoState(event.currentTarget.textContent);
        if (reason == 'selectOption') {
            //console.log('Opcion seleccionada');
            const productoEncontrado = productos.find((producto) => producto.id == value.id);
            //console.log({ productoEncontrado });
            if (productoEncontrado) {
                setCodigoBarrasState(productoEncontrado.codBar);
                SetNombreProductoState(productoEncontrado.product);
                //setMarcaState(productoEncontrado.nombreMarca);
                //setCategoriaState(productoEncontrado.nombreCategoria);
                //llenarDatosExtra(productoEncontrado.nombreProducto);
            } else {
                //setCodigoBarrasState("");
                SetNombreProductoState("");
                //setMarcaState("");
                //setCategoriaState("");
            }
        }
    }

    

    const handleSearchProduct = async (event) => {
        event.preventDefault();
        try {
            //const result = await EnviarIngresarAlmacen(filas, currentUser, dispatch);    
            const result = await ObtenerInformacionProducto('DISPONIBILIDAD', nombreProductoState, currentUser, dispatch);
            if (result.rows) {
                setDisponibilidadProducto(result.rows.map((r) => ({ ...r, mover: 0})));  //mover lleva el dato de cuantos mover
            }
        } catch (error) {

        }

    }

    const handleLog = () => {
        //console.log({ disponibilidadProducto });
    }

    

    return (
        <Box>
            <form
            //</Box>onSubmit={(event) => handleSubmitIngresar(event)}
            >
                <Box paddingBottom={2}>
                    <TextField
                        autoFocus={true}
                        autoComplete='off'      //Para que no salga opciones de texto anteriores
                        margin='normal'
                        variant='outlined'
                        id='codigoBarras'
                        label='Código de Barras'
                        type='text'
                        fullWidth
                        inputRef={codigoBarrasRef}
                        value={codigoBarrasState}
                        onBlur={(event) => handleCodigoBarrasBlur(event)}   //Función cuando pierde el focus
                        onChange={(event) => setCodigoBarrasState(event.target.value)}
                        onFocus={event => event.target.select()}
                        inputProps={{
                            onKeyPress: event => {          //Para gestionar enter
                                const { key } = event;
                                if (key === "Enter") {
                                    handleCodigoBarrasEnter();
                                }
                            },
                            minLength: 8
                        }}
                    />
                </Box>

                <Box paddingBottom={3}>
                    <Autocomplete
                        disablePortal={false}
                        id="combo-box-demo"
                        options={productosOptions}
                        fullWidth
                        renderInput={(params) => <TextField {...params} label="Producto" />}
                        ListboxProps={{ style: { maxHeight: 150 } }}
                        value={nombreProductoState}
                        onChange={(event, value, reason) => handleProductoChange(event, value, reason)}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        required
                    />
                </Box>
                <Stack direction='row' spacing={2} justifyContent='end'>

                    <Button onClick={handleLog} variant="outlined" startIcon={<CancelIcon />}>
                        Cancelar
                    </Button>
                    <Button onClick={handleSearchProduct} type='submit' variant='contained' startIcon={<PlaylistAddIcon />}>
                        Buscar en Almacen
                    </Button>
                </Stack>

                

            </form>
        </Box>
    )
}

export default AlmacenMover